// extracted by mini-css-extract-plugin
export default {"inputWithEditButton":"InputWithEditButton_inputWithEditButton__1KsiJ","spinner":"InputWithEditButton_spinner__-wAr0"};